module.exports = __webpack_public_path__ + "img/new_user_exclusive.726ec05f.png";